module.exports = __webpack_public_path__ + "static/media/xpressGames.5285e649.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/xpressGames.jpg
// module id = 2412
// module chunks = 7